import emotion from 'emotion/dist/emotion.umd.min.js';

const { css } = emotion;

export const formContainer = css`
  position: relative;
  width: 100%;
  padding: 20px 20px 50px;
  @media (max-width: 600px) {
    padding: 20px 10px 40px;
  }
`;

export const form = css`
  max-width: 500px;
  height: 318px;
  overflow: auto;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #dadce0;
`

export const formInner = css`
  padding: 30px 30px;
  @media (max-width: 600px) {
    padding: 30px 20px;
  }
`

export const formTitle = css`
  color: #091b30;
  text-align: center;
  font-size: 20px;
  margin: 0 auto 30px auto;
  @media (max-width: 600px) {
    margin-bottom: 20px;
  }
`;
